export default "__VITE_ASSET__vulqb6Lz__"